/** When your routing table is too long, you can split it into small modules **/
import Layout from "@/layout";

const shopsRouter = {
  path: "/logs",
  component: Layout,
  hidden: true,
  meta: { title: "诊断管理", icon: "el-icon-user", roles: ["admin"] },
  children: [
    {
      path: "edit/:patientid/:id?",
      hidden: true,
      component: () => import("@/pages/logs/edit"),
      name: "edit",
      meta: { title: "诊断编辑" },
    },
    {
      path: "detail/:patientid/:id?",
      hidden: true,
      component: () => import("@/pages/logs/detail"),
      name: "detail",
      meta: { title: "诊断详情" },
    },
  ],
};
export default shopsRouter;
